// extracted by mini-css-extract-plugin
export default {"scrollbar":"Breadcrumbs__scrollbar--lc-IZsV2","component":"Breadcrumbs__component--lc-H7I2c Breadcrumbs__scrollbar--lc-IZsV2"};